import professionSalaryDynamicsButtonClick from '@hh.ru/analytics-js-events/build/career_platform/profession/profession_salary_dynamics_button_click';
import { translation, format, TranslatedComponent } from '@hh.ru/front-static-app';
import { Link, Title, useBreakpoint } from '@hh.ru/magritte-ui';
import { ArrowSquareOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import VacanciesCard from 'src/pages/Profession/components/SectionStatistics/Vacancies/VacanciesCard';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.profession.sections.statistic.vacancies.title',
    link: 'career-platform.profession.sections.statistic.vacancies.link',
};

const Vacancies: TranslatedComponent = ({ trls }) => {
    const {
        currentGrade,
        profession,
        statistic: { topVacancies },
    } = useSelectorNonNullable((state) => state.pageProfession);

    const { isMobile } = useBreakpoint();

    const renderLink = () => (
        <Link
            style="accent"
            typography="label-2-regular"
            href={topVacancies.redirect.link}
            target="_blank"
            onClick={() => professionSalaryDynamicsButtonClick({ buttonName: 'hh_vacancies' })}
            rel="noreferrer noopener nofollow"
            iconRight={<ArrowSquareOutlinedSize16 />}
        >
            {trls[TrlKeys.link]}
        </Link>
    );

    if (!topVacancies.vacancies.length || !currentGrade) {
        return null;
    }

    return (
        <section className={styles.container} data-qa="section-statistics-vacancies">
            <header className={styles.header}>
                <Title size="medium" Element="h2" description={profession.name}>
                    {format(trls[TrlKeys.title], {
                        '{0}': currentGrade ? currentGrade.name.toLowerCase() : '',
                    })}
                </Title>
                {!isMobile && <div className={styles.linkDesktopContainer}>{renderLink()}</div>}
            </header>
            <div className={styles.list}>
                {topVacancies.vacancies.map((item, index) => (
                    <VacanciesCard {...item} professionId={profession.id} gradeId={currentGrade.id} key={index} />
                ))}
            </div>
            {isMobile && <div className={styles.linkMobileContainer}>{renderLink()}</div>}
        </section>
    );
};

export default translation(Vacancies);
